import React from 'react';
import { Award, Zap, Fuel } from 'lucide-react';
import { aboutData } from '../../data/mock-v1';

const AboutV1 = () => {
  return (
    <section id="about" className="py-20 lg:py-32 bg-gradient-to-br from-white to-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Contenido primero */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-[#63E61E]/10 rounded-full mb-4">
            <span className="text-[#63E61E] font-bold text-sm tracking-wide">SOBRE NOSOTROS</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6">
            {aboutData.title}
          </h2>
          
          <div className="space-y-4 text-gray-700 leading-relaxed text-left">
            <p className="text-lg">{aboutData.description}</p>
            <p className="text-lg">{aboutData.description2}</p>
            <p className="text-lg">{aboutData.description3}</p>
          </div>

          {/* Value Proposition Highlight */}
          <div className="bg-gradient-to-r from-[#63E61E]/10 to-[#63E61E]/5 border-l-4 border-[#63E61E] p-6 rounded-r-2xl mt-8">
            <div className="flex items-start space-x-3">
              <Award className="w-6 h-6 text-[#63E61E] flex-shrink-0 mt-1" />
              <div className="text-left">
                <h3 className="font-bold text-gray-900 text-lg mb-2">Nuestro Valor Agregado</h3>
                <p className="text-gray-700">{aboutData.valueProposition}</p>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 pt-8">
            {aboutData.stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl lg:text-3xl font-black text-[#63E61E] mb-2">
                  {stat.number}
                </div>
                <div className="text-sm text-gray-600 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Solo 2 imágenes minimalistas - Una eléctrica y una gasolina */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Vehículo Eléctrico */}
          <div className="relative group">
            <div className="absolute -inset-4 bg-gradient-to-r from-[#63E61E]/20 to-transparent rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
            <div className="relative overflow-hidden rounded-3xl shadow-2xl border-4 border-[#63E61E]">
              <img
                src={aboutData.imageElectric}
                alt="Vehículo Eléctrico Cargando"
                className="w-full h-[400px] object-cover transform group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#63E61E]/30 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-[#63E61E] px-6 py-4 rounded-2xl shadow-xl flex items-center space-x-3">
                  <Zap className="w-8 h-8 text-gray-900" />
                  <div>
                    <h3 className="text-gray-900 font-bold text-xl">Vehículo Eléctrico</h3>
                    <p className="text-gray-800 text-sm">Cargando energía limpia</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Vehículo a Gasolina */}
          <div className="relative group">
            <div className="absolute -inset-4 bg-gradient-to-r from-gray-400/20 to-transparent rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
            <div className="relative overflow-hidden rounded-3xl shadow-2xl border-4 border-gray-300">
              <img
                src={aboutData.imageGasoline}
                alt="Vehículo a Gasolina"
                className="w-full h-[400px] object-cover transform group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/30 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white px-6 py-4 rounded-2xl shadow-xl flex items-center space-x-3">
                  <Fuel className="w-8 h-8 text-gray-900" />
                  <div>
                    <h3 className="text-gray-900 font-bold text-xl">Vehículo a Gasolina</h3>
                    <p className="text-gray-600 text-sm">Repostaje eficiente</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutV1;
